export { fetchModel } from './batched-models';
export type { Request } from './types';
